const toastrFileDownBtn = {
  info1: 'Aguarde!',
  info2: 'Seu documento esta sendo gerado',
  error1: 'Erro!',
  error2: 'Não foi possível baixar o relatório. Tente novamente!'
};

export default toastrFileDownBtn;
